import { Button, Result } from "antd";
import { Link } from "react-router-dom";

/** 403 page shown when a non-admin reaches an operator-only route. */
function Forbidden() {
  return (
    <Result
      status="403"
      title="403"
      subTitle="You don't have permission to view this page."
      extra={
        <Link to="/">
          <Button type="primary">Back to dashboard</Button>
        </Link>
      }
    />
  );
}

export default Forbidden;
